<template>
  <v-select
    :class="classNames"
    v-model="status"
    :disabled="disabled"
    :outlined="!inline"
    :items="statuses"
    item-text="text"
    item-value="value"
    :label="label || 'Litter Status'"
    :rules="required ? [(v) => !!v || `${label || 'Litter Status'} is required`] : null"
    single-line
    @input="$emit('update', $event)"
  ></v-select>
</template>

<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "LitterStatusDropdown",
  props: {
    status: Number,
    required: Boolean,
    disabled: Boolean,
    inline: Boolean,
    classNames: String,
    label: String,
  },
  data: function () {
    return {
      statuses: [
        { value: 1, text: "Registered" },
        { value: 2, text: "Pending" },
        { value: 3, text: "Cancelled" },
      ],
    };
  },
});
</script>